import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import InfoText from '../../../components/common/InfoText';
import formatTimestamp from '../../../components/common/formatTimestamp';
import {TranslationDescriptor} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	label: TranslationDescriptor;
	date: string;
	bubble: TranslationDescriptor;
};

const DateWithInfo = ({label, date, bubble, ...otherProps}: Props) => {
	return (
		<div className="field" {...otherProps}>
			<label>
				<Trans i18nKey={label.id}>{label.defaultValue}</Trans>
			</label>
			<div>
				<InfoText direction="right" bubble={bubble}>
					{formatTimestamp(date)}
				</InfoText>
			</div>
		</div>
	);
};

export default DateWithInfo;
